import React from 'react';
import { useTranslation } from 'react-i18next';
import { siteUrl } from '@common/utils/urlutils';
const A11YMenuAccountBar = () => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: "a11y-action-bar" },
        React.createElement("div", { className: "container" }, window.loggedin ? React.createElement("a", { href: siteUrl('myaccount') }, t('navigation.aria.navigatetoaccount')) : React.createElement("a", { href: siteUrl('login') }, t('navigation.aria.navigatetologin')))));
};
export default A11YMenuAccountBar;
